import { literal } from '../../typing/literal.js';
import { object } from '../../typing/object.js';

export const AuthDeviceExpiredResponse = object('AuthDeviceExpiredResponse', {
  type: literal('expired'),
});
